module.exports = {
  label: {
    name: 'Name',
    phoneNumber: 'Phone Number',
    emailId: 'Email ID',
    dob: 'Date of Birth',
    gender: 'Gender',
    bloodGroup: 'Blood Group',
    address: 'Address',
    nodata:'----',
    male:'Male',
    female:'Female',
    other:'Other',
    noDataFound:'No Data Found',
    error:'Something Went Wrong'
  }
}